(function () {
  'use strict';

  function initReels(root) {
    if (!root || root.dataset.reelsReady === 'true') return;
    root.dataset.reelsReady = 'true';

    var cards = root.querySelectorAll('.reel-card');
    var carousel = root.querySelector('.reel-list');
    var progressWrap = root.querySelector('.reel-progress');
    var progressBar = root.querySelector('.reel-progress__bar');

    if ('IntersectionObserver' in window && cards.length) {
      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;

            if (entry.isIntersecting) {
              if (video.readyState === 0) {
                video.load();
              }
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { root: null, rootMargin: '200px 0px', threshold: 0.35 }
      );

      cards.forEach(function (card) {
        videoObserver.observe(card);
      });

      root._reelVideoObserver = videoObserver;
    }

    root.querySelectorAll('.reel-card__mute').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var card = button.closest('.reel-card');
        var video = card && card.querySelector('video');
        if (!video) return;

        video.muted = !video.muted;
        button.setAttribute('aria-pressed', String(!video.muted));
        button.classList.toggle('is-unmuted', !video.muted);
      });

      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
        button.addEventListener(type, function (event) {
          event.stopPropagation();
        });
      });
    });

    if (carousel && progressWrap && progressBar) {
      var ticking = false;

      var update = function () {
        var scrollable = carousel.scrollWidth - carousel.clientWidth;

        if (scrollable <= 4) {
          progressWrap.hidden = true;
          return;
        }

        progressWrap.hidden = false;

        var trackWidth = progressWrap.clientWidth;
        var thumbWidth = Math.max(24, (carousel.clientWidth / carousel.scrollWidth) * trackWidth);
        var maxTravel = Math.max(0, trackWidth - thumbWidth);
        var ratio = carousel.scrollLeft / scrollable;

        progressBar.style.width = thumbWidth + 'px';
        progressBar.style.transform = 'translateX(' + ratio * maxTravel + 'px)';
      };

      carousel.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(function () {
              update();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );

      window.addEventListener('resize', update);
      update();
    }
  }

  function teardownReels(root) {
    if (root && root._reelVideoObserver) {
      root._reelVideoObserver.disconnect();
      delete root._reelVideoObserver;
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.shop-the-reels').forEach(initReels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('.shop-the-reels')
      : null;

    if (section) {
      teardownReels(section);
      section.dataset.reelsReady = 'false';
      initReels(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('.shop-the-reels')
      : null;

    teardownReels(section);
  });
})();
